import { Text, Heading, Button, Img } from "./..";
import React from "react";

const HomepageColumnclockhist = ({
  extraordinary = "",
  aphraseisa = "",
  ...props
}) => {
  return (
    <div {...props} className={`${props.className} flex flex-col items-center w-[29%] md:w-full gap-4 py-3`}>
      <Button className="flex h-[72px] w-[72px] items-center justify-center rounded-[36px] bg-red-700 px-4">
        <Img src="images/img_clock_history.svg" />
      </Button>
      <Heading as="h6" className="text-base font-bold text-center !text-gray-900">
        {extraordinary}
      </Heading>
      <Text as="p" className="mb-1 w-full text-center text-base font-normal leading-[21px] !text-gray-900">
        {aphraseisa}
      </Text>
    </div>
  );
}

export { HomepageColumnclockhist };